/** Derive a first name from a display name or email local-part, capitalized.
 * Returns null when there's nothing usable (BFF /me may omit name + email). */
export function firstName(source: string | null | undefined): string | null {
  if (!source) return null;
  if (source.includes("@")) {
    const local = source.split("@")[0] ?? "";
    return local ? capitalize(local.split(/[._-]/)[0] ?? "") : null;
  }
  const first = source.trim().split(/\s+/)[0] ?? "";
  return first ? capitalize(first) : null;
}

function capitalize(s: string): string {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/** The long-form date line under the greeting (locale-formatted). */
export function formatToday(now: Date = new Date()): string {
  return now.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
